import React, { useState, useEffect } from 'react'
import Root from 'pages/Root'
import Footer from 'organisms/Footer'
import client from 'api/prismicClient'
import Container from 'atoms/layout/Container'
import Header from 'organisms/Header'
import ImageContentCardList from 'organisms/ImageContentCardList'

export default function Info () {
  const [doc, setDoc] = useState<any>(null)
  useEffect(() => {
    (async () => {
      setDoc(await client.getSingle('info', {}))
    })()
  })

  return (
    <Root>
      <Header/>
      <Container>
        <ImageContentCardList itemList={doc?.data.body[0].items}/>
      </Container>
      <Footer/>
    </Root>
  )
}
